var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M48.927,26.66H30.175a3.517,3.517,0,0,0-3.515,3.515V48.927a3.517,3.517,0,0,0,3.515,3.515H48.927a3.517,3.517,0,0,0,3.515-3.515V30.175a3.517,3.517,0,0,0-3.515-3.515ZM39.551,47.753a8.2,8.2,0,1,1,8.2-8.2A8.2,8.2,0,0,1,39.551,47.753Zm8.2-14.069A2.344,2.344,0,1,1,50.1,31.34,2.344,2.344,0,0,1,47.753,33.684Zm0,0",
    transform: "translate(-19.551 -19.551)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M58.867,53a5.867,5.867,0,1,0,5.867,5.867A5.867,5.867,0,0,0,58.867,53Zm0,0",
    transform: "translate(-38.867 -38.867)",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M34.061,0H5.939A6,6,0,0,0,0,5.939V34.061A6,6,0,0,0,5.939,40H34.061A6,6,0,0,0,40,34.061V5.939A6,6,0,0,0,34.061,0Zm1.173,29.376a5.867,5.867,0,0,1-5.867,5.867H10.624a5.867,5.867,0,0,1-5.867-5.867V10.624a5.867,5.867,0,0,1,5.867-5.867H29.376a5.867,5.867,0,0,1,5.867,5.867Zm0,0",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.cad733ce5014b52118ddf8b6f1047f76.svg";
export { ForwardRef as ReactComponent };